import { useState, useEffect } from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import { useParams, useNavigate } from "react-router-dom";
import StateMap from "../StateMap";
import SchoolsMap from "../../components/SchoolsMap";
import StatesMap from "../../components/StatesMap";
import MEAMap from "../MEAMap/index.js";
import Button from "../../components/Button";
import { mapModes, stateCodeToName, views, viewToRoute } from "../../constants";
import "./styles.css";
import { Global, MapContainer, MapViewToggle } from "./styled.js";
import { MapProvider } from "react-map-gl";
import { filterSchoolsByState } from "../../utils.js";
import schools from "../../data/schools";
import s4sGrantees from "../../data/s4s-grantees";

function App({ mapMode, stateCode, enableS4sGrantees }) {
  const { view } = useParams();

  let defaultMapView;
  if(view) {
    defaultMapView = viewToRoute[view];
  } else {
   defaultMapView = mapMode === mapModes.STATE ? views.STATE_DISTRICTS : views.SCHOOLS;
  }

  const navigate = useNavigate();
  const [mapView, setMapView] = useState(defaultMapView);
  const [schoolsData, setSchoolsData] = useState([]);
  const stateName = stateCodeToName[stateCode];

  useEffect(() => {
    const route = viewToRoute[mapView];
    if (mapMode === mapModes.STATE) {
      navigate(`/${stateCode.toLowerCase()}${route ? `/${route}` : ""}`);
      if (mapView === views.S4S_GRANTEES) {
        setSchoolsData(filterSchoolsByState([...s4sGrantees], stateCode));
      } else {
        setSchoolsData(filterSchoolsByState([...schools], stateCode));
      }
    } else if(!mapMode) {
      navigate(`${route ? `/${route}` : ""}`);
    }
  }, [mapView, mapMode, navigate, stateCode]);

  const onViewChange = (view) => {
    setMapView(view);
  };

  const stateMap = (
    <StateMap
      stateName={stateName}
      stateCode={stateCode}
      schoolsData={schoolsData}
      onViewChange={onViewChange}
      enableS4sGrantees={enableS4sGrantees}
      mapView={mapView}
    />
  );

  const meaMap = (
    <MEAMap
      stateName={stateName}
      stateCode={stateCode}
      schoolsData={schoolsData}
      mapView={mapView}
    />
  );

  const defaultMap = (
    <>
      <MapViewToggle>
        <Button
          type="light"
          isActive={mapView === views.SCHOOLS}
          onClick={() => onViewChange(views.SCHOOLS)}
        >
          School
        </Button>
        <Button
          type="light"
          isActive={mapView === views.STATES}
          onClick={() => onViewChange(views.STATES)}
        >
          State
        </Button>
      </MapViewToggle>
      {mapView === views.SCHOOLS && <SchoolsMap />}
      {mapView === views.STATES && <StatesMap />}
    </>
  );

  const getMap = () => {
    switch (mapMode) {
      case mapModes.STATE:
        return stateMap;
      case mapModes.MEA:
        return meaMap;
      default:
        return defaultMap;
    }
  };

  return (
    <MapProvider>
      <Global>
        <MapContainer>{getMap()}</MapContainer>
      </Global>
    </MapProvider>
  );
}

export default App;
